<template>
  <div :id="thisId">
    <!--   普通模式-->
    <slot v-if="!standalone"></slot>
    <!--    独立模式-->
    <div v-else class="standalone" @click="clickStandaloneBody">
      <slot></slot>
      <div v-if="showStandalone">
        <img :src="loadPreFix(img.src)" :alt="img.alt" v-for="(img,index) of standaloneImgList" :key="index">
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.standalone{
  cursor: pointer;
  img{
    display: none;
  }
}
</style>
<style  lang="scss">
@import './viewer.css';
.viewer-backdrop {
  background-color: rgba(255, 255, 255,1);
}
.viewer-button {
  background-color: rgb(247, 0, 0);
}
.viewer-button:focus, .viewer-button:hover {
  background-color: rgba(177, 14, 14, 0.8);
}
</style>


<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/img-viewer/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/img-viewer/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/img-viewer/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-img-viewer')
  export default {
    name: 'base-img-viewer', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-img-viewer': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>